<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">项目资料详情</div>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
        <el-form
          ref="form"
          :model="uploadData"
          :rules="rules"
          label-width="16rem"
          style="width: 80%">
          <el-row>
            <el-col :span="12">
              <el-form-item label="所属项目" prop="Extends1">
                <el-select v-model="uploadData.Extends1" placeholder="请选择" @change="setProject(uploadData.Extends1)" style="width: 100%;">
                  <el-option
                    v-for="item in ProjectList"
                    :key="item.ID"
                    :label="item.ProjectName"
                    :value="item.ID"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文档分类" prop="Extends2">
                <el-select v-model="uploadData.Extends2" placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in FileTypeList"
                    :key="item.ParameterKey"
                    :label="item.ParameterName"
                    :value="item.ParameterName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="文档上传" prop="Slices" ref="fileUpload">
              <el-upload
                :http-request="httpRequest"
                :show-file-list="isShowList"
                :before-upload="beforeupload"
                :on-success="uploadsuccess"
                :on-progress="uploadProgress"
                :on-error="uploadError"
                :multiple="true"
                :file-list="fileList">
                <el-button size="mini" type="primary">上 传</el-button>
              </el-upload>  
            </el-form-item>
          </el-row>
        </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-form>
        <el-form-item class="right" style="width: 134rem;padding-right:5rem">
          <el-button @click="onBack()">返回</el-button>
          <el-button type="primary" @click="saveForm()">保存</el-button>
        </el-form-item>
      </el-form>
    </zj-layout-footer>
  </zj-layout-container>
</template>


<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
export default {
  name: "FileInfo",
  controller: "UI",
  action: "FileInfo",
  components: {
    
  },
  computed: {
    // httpRequest() {
    //   return ZJApp.ZJApis.ZJUploader.upload;
    // }
  },
  data() {
    return {
      ProjectList: [],
      FileTypeList: [
        {
          ParameterKey: '1',
          ParameterName: '合同'
        },
        {
          ParameterKey: '2',
          ParameterName: '设计资料'
        },
        {
          ParameterKey: '3',
          ParameterName: '过程文档'
        },
        {
          ParameterKey: '4',
          ParameterName: '验收资料'
        }
      ],
      fileList: [],
      isShowList: false,
      uploadData: {
        //todo
        Module: "", //模块名
        AssocID: "", //业务ID
        SubModule: "", //子模块

        Slices: [],
        Uploader: ZJApp.ZJUser.current.UserName, //上传人
        Folder: "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        Extends1: "", //扩展字段 1
        Extends2: "", //扩展字段 2
        Extends3: 0, //扩展字段 3
        FileName: ""
      },
      
      loading: false,
      loadingText: "加载中...",
      IsEdit: true,
      
      rules: {
        Extends1: [{ required: true, message: "请选择所属项目", trigger: "blur" }],
        Extends2: [{ required: true, message: "文档分类", trigger: "blur" }],
        Slices: [{ required: true, message: "请上传", trigger: "change" }]
      },
    };
  },
  created() {
    this.GetProject();
    // this.GetMaterialFileType();
  },
  mounted() {},
  methods: {
    setProject(val) {
      
      this.ProjectList.some(item => {
        if (val === item.ID) {
          this.uploadData.SubModule = item.ProjectName
        }
        return val === item.ID
      })
      console.log(this.uploadData.SubModule)
    },
    GetMaterialFileType() {
      new MyApis.MaterialConfigurationApi()
        .GetAllMaterialFileType()
        .then((r) => {
          r = r.data.Data;
          this.FileTypeList = r.PageContents;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    GetProject() {
      let searchinfo = {
        PageSize: 999,
        PageIndex: 1,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.ProjectBasicinfoApi()
        .GetPageContentByConditions(searchinfo)
        .then((r) => {
          r = r.data.Data;
          this.ProjectList = r.ContentList;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    httpRequest(params) {
      console.log(params)
      const _file = params.file
      let form = new FormData();
      form.append("file", _file);
      this.uploadData.FileName = _file.name;
      // this.rules.updetaFile = []
      // this.$refs.fileUpload.clearValidate(); // 关闭校验
      new MyApis.FileApi()
        .UploadSlice(form)
        .then((r) => {
          r = r.data.Data;
          this.loading = false;
          this.isShowList = true
          this.uploadData.Slices.push(r[0].SliceID)
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    beforeupload: function () {
      this.loading = true;
      this.loadingText = "上传中... 0%";
    },
    uploadsuccess: function () {
      this.loadingText = "上传成功";
      this.loading = false;
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      console.log(e.percent)
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    saveForm() {
      this.uploadData.AssocID = this.$route.query.assocID
      this.uploadData.Module = this.$route.query.module
      console.log(11, this.fileList)
      this.$refs.form.validate((valid) => {
         console.log(22)
        if (valid) {
          this.loading = true;
          this.loadingText = "保存中...";
          this.Add();
        } else {
          return false;
        }
      });
    },
    Add() {
      new MyApis.FileApi()
        .CreateSuperFile(this.uploadData)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    }
  }
};
</script>
